<!--
 * @Author: chen 1251900949@qq.com
 * @Date: 2024-01-17 14:24:20
 * @LastEditors: Tang Hao
 * @LastEditTime: 2026-02-12 10:16:42
 * @FilePath: \tax-web\found\views\cps\views\haipu_terminal\terminal _authentication\table.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<script>
import TablePage from '@/found/components/table_page';
import request from '@/found/utils/request';
// import Form from './form';

export default {
  extends: TablePage,
  // components: {
  //   Form,
  // },
  data() {
    return {
      // requestType: 'POST',
    };
  },
  mounted() {
    this.getConfigList('cps_terminal _authentication_list');
  },
  methods: {
    clickVisible({ val, row }) {
      // if (row.signStatus !== '3000') {
      //   if (val.buttonName === '清除认证') { // 2026.2.12 所有数据都需要展示 清除认证 按钮
      //     return false;
      //   }
      // }
      return true;
    },
    modalClick({
      val,
      row,
    }) {
      if (val.code === 'clean_up') {
        this.$confirm('是否清除认证?', '清除认证', {
          confirmButtonText: '确认',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(() => {
            request.get('/tax/v1/terminalCash/api/clearVerifyInfo', { id: row.id }).then((res) => {
              if (res.success) {
                this.$message({
                  type: 'success',
                  message: '清除认证成功',
                });
                this.getList();
              }
            }).finally(() => {
              this.pageLoading = false;
            });
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: '已取消',
            });
          });
      }
    },
  },
};
</script>
